// A café's billing state in words, from the two fields /internal/cafes sends
// (fee_starts_at, fee_active). The same rule and wording as the café page's
// badge and Billing & Revenue's "Billing from": no date = free trial, a date
// not reached = trial until then, fee_active = paying.

const DAY_MS = 86400000;
// A trial ending within this many days says so in words.
export const TRIAL_SOON_DAYS = 7;

const toMs = (iso) => {
    if (!iso) return null;
    const t = new Date(/[zZ]|[+-]\d{2}:?\d{2}$/.test(iso) ? iso : `${iso}Z`).getTime();
    return Number.isNaN(t) ? null : t;
};

const dayText = (iso) => new Date(toMs(iso)).toLocaleDateString('en-IN', {
    day: 'numeric', month: 'short', timeZone: 'Asia/Kolkata',
});

/** Whole days until the fee starts; null when paying or no date is set. */
export function trialDaysLeft(cafe) {
    if (cafe.fee_active) return null;
    const t = toMs(cafe.fee_starts_at);
    return t == null ? null : Math.ceil((t - Date.now()) / DAY_MS);
}

/** {label, color, soon} for a badge. */
export function billingBadge(cafe) {
    if (cafe.fee_active) return { label: `Paying since ${dayText(cafe.fee_starts_at)}`, color: 'success' };
    if (!toMs(cafe.fee_starts_at)) return { label: 'Free trial', color: 'neutral' };
    const days = trialDaysLeft(cafe);
    if (days != null && days >= 0 && days <= TRIAL_SOON_DAYS) {
        return { label: `Trial ends ${days === 0 ? 'today' : `in ${days} day${days === 1 ? '' : 's'}`}`, color: 'warning', soon: true };
    }
    return { label: `Trial until ${dayText(cafe.fee_starts_at)}`, color: 'warning' };
}
